import { render, staticRenderFns } from "./PersonalProfileEdit.vue?vue&type=template&id=0f6337d2&"
import script from "./PersonalProfileEdit.vue?vue&type=script&lang=js&"
export * from "./PersonalProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports